import {
  APPLIANCES_FETCH_STARTED,
  APPLIANCES_FETCH_SUCCEEDED,
  APPLIANCES_FETCH_FAILED,
  APPLIANCES_CLEAR,
  APPLIANCE_DEVICES_MERGE_TO_APPLIANCE
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  appliances: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APPLIANCES_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case APPLIANCES_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        appliances: action.payload
      };
    case APPLIANCE_DEVICES_MERGE_TO_APPLIANCE:
      const appliancesWithDevices = action.payload;
      return {
        ...state,
        appliances: state.appliances.map(appliance => {
          const withDevices = appliancesWithDevices.filter(applianceWithDevices =>
            applianceWithDevices.applianceId === appliance.id);

          if (withDevices.length) {
            const devices = withDevices.reduce((a, c) => {
              if (!a[c.applianceId]) {
                return { [c.applianceId]: c.devices };
              }
              return { [c.applianceId]: a[c.applianceId].concat(c.devices) };
            }, {});

            return {
              ...appliance,
              applianceDevices: devices[appliance.id]
            };
          }

          return appliance;
        })
      };
    case APPLIANCES_FETCH_FAILED:
      return { ...state, status: statuses.failed, appliances: [], error: action.error };
    case APPLIANCES_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
